// Firestore repository for Experience Engine Passport data.
// Demo stops use the production Engagement Engine schema so the generated
// experience can be exercised immediately through the real Passport UI.

import {
  collection,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

const ENGAGEMENT_ACTIVITIES_COLLECTION = "engagement_activities";

const normalizeCode = (value = "") =>
  String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "");

const getStopType = (stop = {}) => {
  if (stop.module === "sponsors") return "sponsor";
  if (stop.module === "vendors") return "vendor";
  if (stop.module === "volunteers") return "volunteer";
  return "event";
};

export const savePassportData = async ({
  demoContext,
  stops = [],
} = {}) => {
  console.log("Saving Passport demo data.");

  const eventId =
    demoContext?.eventId ||
    demoContext?.eventResult?.eventId ||
    demoContext?.event?.eventId;

  if (!eventId) {
    throw new Error("Passport Repository requires an eventId.");
  }

  const batch = writeBatch(db);
  const savedStops = [];

  stops.forEach((stop) => {
    const stopRef = doc(
      collection(db, "events", eventId, ENGAGEMENT_ACTIVITIES_COLLECTION)
    );
    const publicCode = normalizeCode(stop.qrCodeLabel || stop.localKey);

    const stopData = {
      eventId,
      title: stop.title || "Passport Stop",
      description: stop.description || "",
      activityType: stop.completionAction || "event_location_checkin",
      stopType: getStopType(stop),
      sourceModule: stop.module || "events",
      sourceType: stop.type || "event",
      sourceId: stop.relatedId || "",
      publicCode,
      publicCodeNormalized: publicCode,
      qrCode: publicCode,
      qrCodeNormalized: publicCode,
      bonusCode: "",
      bonusCodeNormalized: "",
      qrEnabled: true,
      manualCodeEnabled: true,
      bonusCodeEnabled: false,
      points: Number(stop.points || 0),
      raffleEntries: 1,
      bonusPoints: 0,
      bonusRaffleEntries: 0,
      maxCompletionsPerUser: 1,
      active: stop.active !== false,
      visibleToPublic: true,
      displayOrder: Number(stop.displayOrder || 0),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      demoSeed: true,
    };

    batch.set(stopRef, stopData);
    savedStops.push({ ...stopData, id: stopRef.id });
  });

  await batch.commit();

  console.log("Passport Engine repository completed.", {
    stops: savedStops.length,
  });

  // Rewards, achievements, and progress are intentionally not fabricated.
  // The production redemption callable owns those immutable records.
  return {
    stops: savedStops,
    rewards: [],
    achievements: [],
    progress: [],
  };
};
